import { render, staticRenderFns } from "./dormModifyQuery.vue?vue&type=template&id=33197b05&scoped=true"
import script from "./dormModifyQuery.vue?vue&type=script&lang=js"
export * from "./dormModifyQuery.vue?vue&type=script&lang=js"
import style0 from "./dormModifyQuery.vue?vue&type=style&index=0&id=33197b05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33197b05",
  null
  
)

export default component.exports